// extracted by mini-css-extract-plugin
module.exports = {"badgesContainer":"ArtistInfoBadges_badgesContainer__6kFmL","badgeField":"ArtistInfoBadges_badgeField__qGZSs","badgeTitle":"ArtistInfoBadges_badgeTitle__lfiwk"};